<template>
  <div class="wrapper">
    <van-checkbox-group v-model="result">
      <van-checkbox v-for="(item, index) in datas" :key="index" :name="item">
        {{ item.content }}
        <template #icon="props">
          <img
            class="img-icon"
            :src="props.checked ? activeIcon : inactiveIcon"
          />
        </template>
      </van-checkbox>
    </van-checkbox-group>
  </div>
</template>

<script>
import { Checkbox, CheckboxGroup } from 'vant'
export default {
  components: {
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup
  },
  props: {
    datas: {
      type: Array,
      default: () => []
    },
    val: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      result: [],
      activeIcon:
        'https://hzwimspic-1251601690.image.myqcloud.com/e0ab4b27-8fd9-4023-9661-ba79b2586bed',
      inactiveIcon:
        'https://hzwimspic-1251601690.image.myqcloud.com/c00a5f9d-8619-4c3b-857d-d007be1b8f4a'
    }
  },
  watch: {
    result() {
      this.$emit('input', this.result)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/css/mixin.scss';
.wrapper {
  padding-bottom: rem(20px);
}
/deep/ .van-checkbox {
  margin-top: rem(15px);
  .van-checkbox__icon {
    height: auto;
  }
  .van-checkbox__label {
    font-size: rem(26px);
    color: #262626;
  }
}
.img-icon {
  width: rem(40px);
  height: rem(40px);
}
</style>
